module.exports = __webpack_public_path__ + "static/media/WS.356b32a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/WS.svg
// module id = 392
// module chunks = 0